'use client'
import React from 'react';
import style from './style.module.scss';
import { api } from '@/constants';
import Image from 'next/image';
import Link from 'next/link';

interface LogoProps {
  isHeader?: boolean;
}
export const Logo = async ({ isHeader }: LogoProps) => {
  const getSocial = async () => {
    return api.contacts.getSocial();
  };
  const response = await getSocial();
  return (
    <div className={style.content}>
      {isHeader ? (
        <Link href="/" className={style.logo}>
          <Image
            width={60}
            height={60}
            //@ts-ignore
            src={process.env.NEXT_PUBLIC_APP_UPLOAD_URL + response?.data.logo?.url}
            alt="logo"
          />
          <h1 className={style.title}>
            Союзники. <span>ОДКБ</span>
            <p className="">Информационно-аналитическое издание</p>
          </h1>
        </Link>
      ) : (
        <div className={style.logo}>
          <Image
            width={60}
            height={60}
            //@ts-ignore
            src={process.env.NEXT_PUBLIC_APP_UPLOAD_URL + response?.data.logo?.url}
            alt="logo"
          />
          <h1 className={style.title}>
            Союзники. <span>ОДКБ</span>
            <p className="">Информационно-аналитическое издание</p>
          </h1>
        </div>
      )}
    </div>
  );
};
